<template>
  <nav id="pages">
    <div>
      <router-link :class="['prev',{'disable':page <= 1}]" :to="prevLink"><img src="@/../public/static/img/blockView/prev.png"></router-link>
      <span>
        <router-link
         :class="{'active':item.page == page,'phone_hide': item.facility=='pc'}"
         :to="item.link" 
         v-for="(item,index) in arr" 
         :key="index"
         >
         {{item.page}}
        </router-link>
      </span>
      <router-link :class="['next',{'disable': page >= pageCount}]" :to="nextLink"><img src="@/../public/static/img/blockView/next.png"></router-link>
    </div>
  </nav>
</template>

<script>
  export default {
    name:'Pages',
    data() {
      return {
        arr: [],
        link: '',
        prevLink: '',
        nextLink: '',
      }
    },
    watch: {
      page(val1,val2) {
        this.init();
      },
      pageCount() {
        this.init();
      }
    },
    props: [
      'toLink',
      'pageCount',
      'page',
      'hid',
      'chainNum',
      'id',
      'address'
    ],
    methods: {
      init(){
        this.arr = [];
        if(this.page <= 1){
          this.prevLink = this.linkOut(1);
        }else{
          this.prevLink = this.linkOut(this.page-1);
        }
        if(this.page >= this.pageCount){
          this.nextLink = this.linkOut(this.pageCount);
        }else{
          this.nextLink = this.linkOut(this.page+1);
        }
        

          console.log(this.pageCount);

        var n = Math.min(5,this.pageCount);
        if(this.page<=3){
          for(var i=0;i<n;i++){
            this.arr.push({
              page: i+1,
              link: this.linkOut(i+1),
            });
          }
        } else if(this.page <= this.pageCount-3){
          for(var i=this.page-2;i<=this.page+2;i++){
            console.log(i);
            this.arr.push({
              page: i,
              link: this.linkOut(i),
            });
          }
        }else{
          for(var i = this.pageCount-4; i <= this.pageCount; i++){
            this.arr.push({
              page: i,
              link: this.linkOut(i),
            });
          }
        }

        var Multipage = 50;
        if(this.page >= (Multipage+1)){
          this.arr.unshift({
            page: '...',
            link: '',
            facility: 'pc'
          })
          this.arr.unshift({
            page: this.page-Multipage,
            link: this.linkOut(this.page-Multipage),
            facility: 'pc'
          });
        }
        if(this.pageCount-this.page>=Multipage){
          this.arr.push({
            page: '...',
            link: '',
            facility: 'pc'
          })
          this.arr.push({
            page: this.page+Multipage,
            link: this.linkOut(this.page+Multipage),
            facility: 'pc'
          });
        }
        console.log(this.arr);
      },
      linkOut(page){
        if(this.toLink == 'BrowserHome'){
          return `/${this.toLink}/${page}`
        }else if(this.toLink == 'HyperblockView'){
          return `/${this.toLink}/${this.hid}/${page}`
        }else if(this.toLink == 'LocalchainView'){
          return `/${this.toLink}/${this.hid}/${this.chainNum}/${page}`
        }else if(this.toLink == 'LocalBlockView'){
          return `/${this.toLink}/${this.hid}/${this.chainNum}/${this.id}/${page}`
        }else if (this.toLink == 'TxList') {
          return `/${this.toLink}/${this.address}/${page}`
        }
      }
    },
    mounted(){
      this.init();
    },
  }
</script>

<style scoped lang="scss">
  @media screen and (max-width: 768px) {
    .phone_hide{
      display: none!important;
    }
  }
</style>